(function () {
  "use strict";

  const root = document.getElementById("chatbot-faq");
  if (!root) return;

  const launcher = root.querySelector(".chatbot-faq__launcher");
  const panel = root.querySelector(".chatbot-faq__panel");
  const closeBtn = root.querySelector(".chatbot-faq__close");
  const log = root.querySelector("[data-chatbot-log]");
  const restartBtn = root.querySelector("[data-chatbot-restart]");
  const backBtn = root.querySelector("[data-chatbot-back]");
  const mypageUrl = root.dataset.mypageUrl || "/account";
  const workerUrl = (root.dataset.workerUrl || "").replace(/\/+$/, "");
  const turnstileSiteKey = root.dataset.turnstileSiteKey || "";
  const formHost = root.querySelector(".chatbot-faq__form-host");
  let turnstileWidgetId = null;
  let turnstileRendered = false;
  let turnstileReady = false;
  let pendingTurnstileRender = false;
  let submitted = false;

  const I18N = {
    open_link: window.theme?.strings?.chatbot_open_link || "開く",
    back: window.theme?.strings?.chatbot_back || "戻る",
    submit_success: "お問い合わせありがとうございます。3営業日以内に担当者よりご返信いたします。",
    submit_error: "ネットワークエラーが生じました。しばらく時間をおいてからお問い合わせください。",
  };

  const SCENARIO = {
    start: {
      type: "choice",
      title: "Q&A・お問い合わせを開始します。ご用件をお選びください。",
      choices: [
        { label: "Q&A・お問い合わせ", next: "qa_main" },
        { label: "YOBEK：購入履歴", next: "mypage" },
      ],
    },
    mypage: {
      type: "link",
      body: "マイページ（購入履歴・配送状況）へ遷移します。",
      label: "マイページを開く",
      url: () => mypageUrl,
    },
    qa_main: {
      type: "choice",
      title: "ご質問のカテゴリーをお選びください。",
      choices: [
        { label: "注文について", next: "orders" },
        { label: "配送について", next: "shipping" },
        { label: "支払いについて", next: "payment" },
        { label: "返品/交換/キャンセルについて", next: "returns" },
        { label: "アカウントについて", next: "account" },
        { label: "直接のお問い合わせ", next: "contact_direct" },
      ],
    },
    orders: {
      type: "choice",
      title: "「注文について」のご質問をお選びください。",
      choices: [
        { label: "注文状況を確認したい", next: "order_status" },
        { label: "配送先住所を変更したい", next: "address_change" },
        { label: "商品に不備がありました", next: "defect" },
        { label: "領収書を発行してほしい", next: "receipt" },
      ],
    },
    shipping: {
      type: "choice",
      title: "「配送について」のご質問をお選びください。",
      choices: [
        { label: "配送状況を確認したい", next: "shipping_status" },
        { label: "送料について", next: "shipping_fee" },
        { label: "商品発送時に連絡がほしい", next: "shipping_notify" },
        { label: "商品を受け取れなかった場合", next: "not_received" },
        { label: "配送の日時指定は可能ですか？", next: "time_designate" },
        { label: "配送業者を指定できますか？", next: "carrier_designate" },
        { label: "海外への配送について", next: "overseas" },
      ],
    },
    payment: {
      type: "choice",
      title: "「支払いについて」のご質問をお選びください。",
      choices: [
        { label: "支払い方法を知りたい", next: "payment_methods" },
        { label: "支払い方法の変更は可能ですか？", next: "payment_change" },
      ],
    },
    returns: {
      type: "choice",
      title: "「返品/交換/キャンセル」のご質問をお選びください。",
      choices: [
        { label: "返品・交換したい", next: "return_exchange" },
        { label: "キャンセルしたい", next: "cancel" },
        { label: "お客様都合による返品・交換", next: "customer_return" },
      ],
    },
    account: {
      type: "choice",
      title: "「アカウントについて」のご質問をお選びください。",
      choices: [
        { label: "アカウント登録するとできること", next: "account_benefits" },
        { label: "マイページへログインができない", next: "login_issue" },
        { label: "アカウント登録をしたい", next: "account_link" },
      ],
    },

    order_status: {
      type: "text",
      body:
        "マイページの「購入履歴・配送状況」よりご確認いただけます。\n" +
        "ログインがお済みでない方は、下記よりログインしてください。",
      followUp: { label: "マイページを開く", url: () => mypageUrl },
      end: true,
    },
    address_change: {
      type: "text",
      body:
        "ご注文確定後は、自動的に商品の手配および出荷準備へと進むため、未発送の場合も原則として配送先住所の変更は承っておりません。\n" +
        "発送済みの場合は、直接配送会社へお問い合わせください。",
      followUp: { label: "配送状況を確認する", url: () => mypageUrl },
      end: true,
    },
    defect: {
      type: "text",
      body:
        "大変申し訳ございませんでした。すぐにご対応いたしますので、お問い合わせフォームより必要事項をご明記の上、ご連絡ください。\n" +
        "破損があった場合は、状態がわかる写真をお問い合わせ後にお送りください。",
      end: true,
    },
    receipt: {
      type: "text",
      body:
        "領収書につきましては、マイページよりダウンロードいただけます。ログイン後、マイページよりご確認ください。",
      followUp: { label: "マイページを開く", url: () => mypageUrl },
      end: true,
    },

    shipping_status: {
      type: "text",
      body:
        "マイページの「購入履歴・配送状況」よりご確認いただけます。\n" +
        "商品の発送はご注文から5営業日以内となります。\n" +
        "※予約商品の場合は異なります。各商品の詳細をご確認ください。",
      followUp: { label: "マイページを開く", url: () => mypageUrl },
      end: true,
    },
    shipping_fee: {
      type: "text",
      body:
        "配送料 600円（税込：660円）。\n" +
        "北海道、沖縄、離島への配送は 1,200円（税込：1,320円）。\n" +
        "1回のご決済で 10,000円（税込：11,000円）以上お買い上げの方は全国送料無料。",
      end: true,
    },
    shipping_notify: {
      type: "text",
      body: "ご登録のメールアドレスへ発送案内のメッセージをお送りしています。",
      end: true,
    },
    not_received: {
      type: "text",
      body:
        "ご不在時には、ヤマト運輸のドライバーがポストにご不在時連絡票をお入れします。\n" +
        "そちらに記載されているお近くのヤマト運輸の営業所へお問い合わせください。\n" +
        "保管期間を過ぎたお荷物は、お受け取り辞退となり当店へ返品されますのでご注意ください。",
      end: true,
    },
    time_designate: {
      type: "text",
      body: "現在、配送の日時指定は出来ません。",
      end: true,
    },
    carrier_designate: {
      type: "text",
      body: "誠に申し訳ございませんが、配送業者の指定は承っておりません。",
      end: true,
    },
    overseas: {
      type: "text",
      body: "現在、海外への配送は行っておりません。",
      end: true,
    },

    payment_methods: {
      type: "text",
      body:
        "クレジットカード決済、Amazon Pay、PayPay、楽天ペイに対応しております。\n" +
        "クレジットカードブランド：VISA・MASTER・AMEX・JCB。\n" +
        "エクスプレスチェックアウト：Shop Pay・Apple Pay・Google Pay、Amazon Pay。\n" +
        "コンビニ支払いまたは銀行振込をご希望の方は、あと払い（Paidy）をご選択ください。",
      end: true,
    },
    payment_change: {
      type: "text",
      body: "ご注文後の変更はできかねます。ご注文時にお間違いないようご注意ください。",
      end: true,
    },

    return_exchange: {
      type: "text",
      body:
        "商品到着後5日以内にご連絡いただいた場合のみ、返品・返金対応を承ります。\n" +
        "商品に欠陥がある場合、状態を確認できる画像をご用意のうえお問い合わせください。\n" +
        "なお、お客様都合での返品・返金はお受けできませんのであらかじめご了承ください。",
      end: true,
    },
    cancel: {
      type: "text",
      body: "ご注文確定後のお客様都合による注文のキャンセル及び商品の返品、交換は受け付けられませんのでご了承ください。",
      end: true,
    },
    customer_return: {
      type: "text",
      body:
        "弊社ではお客様都合での返品はお受けできません。\n" +
        "※当店は通信販売のため、クーリングオフは適用外となります。",
      end: true,
    },

    account_benefits: {
      type: "text",
      body:
        "アカウント登録をしていただくと以下のようなことができます。\n" +
        "■ 購入履歴・配送状況をマイページから確認できる\n" +
        "■ 会員限定のお得情報を受け取れる\n" +
        "■ Q&A から簡単にお問合せができる",
      end: true,
    },
    login_issue: {
      type: "text",
      body:
        "ログインが出来ないケースは以下が考えられます。\n" +
        "・メールアドレスまたはパスワードが一致していない\n" +
        "ご不明な場合はお問い合わせフォームよりご連絡ください。",
      end: true,
    },
    account_link: {
      type: "text",
      body: "マイページよりアカウント登録・ログインのうえ、ご利用ください。",
      followUp: { label: "マイページを開く", url: () => mypageUrl },
      end: true,
    },

    contact_direct: {
      type: "form",
      title: "【直接のお問い合わせ】",
      body: "下記フォームよりご連絡ください。",
      category: "contact_direct",
    },
  };

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, (m) => ({
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
    }[m]));
  }

  function linkify(text) {
    const escaped = escapeHtml(text).replace(/\n/g, "<br>");
    return escaped.replace(/(https?:\/\/[^\s<]+)/g, '<a href="$1" target="_blank" rel="noopener">$1</a>');
  }

  function appendBubble(html, who) {
    const div = document.createElement("div");
    div.className = "chatbot-faq__bubble chatbot-faq__bubble--" + who;
    div.innerHTML = html;
    log.appendChild(div);
    log.scrollTop = log.scrollHeight;
    return div;
  }

  function appendChoices(node) {
    const wrap = document.createElement("div");
    wrap.className = "chatbot-faq__choices";
    node.choices.forEach((c) => {
      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "chatbot-faq__choice";
      btn.textContent = c.label;
      btn.addEventListener("click", () => {
        Array.from(wrap.querySelectorAll("button")).forEach((b) => b.classList.add("chatbot-faq__choice--disabled"));
        appendBubble(escapeHtml(c.label), "user");
        goTo(c.next);
      });
      wrap.appendChild(btn);
    });
    log.appendChild(wrap);
    log.scrollTop = log.scrollHeight;
  }

  function whenTurnstileReady(cb) {
    // turnstile.ready() は async/defer 付きの script タグでは使えない仕様のため、
    // window.turnstile.render の存在を直接 polling する。
    const tick = () => {
      if (window.turnstile && typeof window.turnstile.render === "function") {
        cb();
        return;
      }
      setTimeout(tick, 50);
    };
    tick();
  }

  function renderTurnstile() {
    if (turnstileRendered || !turnstileSiteKey) return;
    const container = log.querySelector("[data-chatbot-turnstile]")
      || formHost?.querySelector("[data-chatbot-turnstile]");
    if (!container) {
      pendingTurnstileRender = true;
      return;
    }
    if (!turnstileReady || !window.turnstile) {
      pendingTurnstileRender = true;
      return;
    }
    turnstileWidgetId = window.turnstile.render(container, {
      sitekey: turnstileSiteKey,
      size: "flexible",
      theme: "light",
    });
    turnstileRendered = true;
  }

  function readTurnstileToken() {
    if (!turnstileSiteKey || !window.turnstile || turnstileWidgetId === null) return "";
    try {
      return window.turnstile.getResponse(turnstileWidgetId) || "";
    } catch {
      return "";
    }
  }

  function resetTurnstile() {
    if (!window.turnstile || turnstileWidgetId === null) return;
    try { window.turnstile.reset(turnstileWidgetId); } catch {}
  }

  function destroyTurnstile() {
    if (window.turnstile && turnstileWidgetId !== null) {
      try { window.turnstile.remove(turnstileWidgetId); } catch {}
    }
    turnstileWidgetId = null;
    turnstileRendered = false;
    pendingTurnstileRender = false;
  }

  if (turnstileSiteKey) {
    try {
      whenTurnstileReady(() => {
        try {
          turnstileReady = true;
          if (pendingTurnstileRender) {
            pendingTurnstileRender = false;
            renderTurnstile();
          }
        } catch (err) {
          console.error("[chatbot-faq] turnstile ready callback failed", err);
        }
      });
    } catch (err) {
      console.error("[chatbot-faq] turnstile bootstrap failed", err);
    }
  }

  function appendInlineForm(node) {
    // 念のため形がどこにあっても拾えるよう root から探す
    const form = root.querySelector(".chatbot-faq__form");
    if (!form) return;

    // 念のため Turnstile 既存 widget と古いエラー表示を破棄してから新 container に再 render
    destroyTurnstile();
    clearInlineErrors(form);

    const textarea = form.querySelector('textarea[name="contact[body]"]');
    if (textarea) textarea.value = node.prefill || "";

    const wrap = document.createElement("div");
    wrap.className = "chatbot-faq__form-wrap chatbot-faq__bubble chatbot-faq__bubble--bot";
    wrap.appendChild(form);
    log.appendChild(wrap);
    log.scrollTop = log.scrollHeight;
    renderTurnstile();
  }

  function rescueForm() {
    const form = log.querySelector(".chatbot-faq__form");
    if (form && formHost) {
      destroyTurnstile();
      clearInlineErrors(form);
      form.reset?.();
      formHost.appendChild(form);
    }
  }

  function setSubmitting(form, submitting) {
    const btn = form.querySelector(".chatbot-faq__submit");
    if (!btn) return;
    btn.disabled = submitting;
    btn.classList.toggle("chatbot-faq__submit--loading", submitting);
    btn.setAttribute("aria-busy", submitting ? "true" : "false");
    const label = btn.querySelector(".chatbot-faq__submit-label");
    if (label) label.textContent = submitting ? "送信中" : "送信する";
  }

  function buildPayload(form, turnstileToken) {
    const rawPhone = form.elements.namedItem("contact[phone]")?.value?.trim() || "";
    return {
      name: form.elements.namedItem("contact[name]")?.value?.trim() || "",
      email: form.elements.namedItem("contact[email]")?.value?.trim() || "",
      phone: rawPhone.replace(/[^\d]/g, ""),
      body: form.elements.namedItem("contact[body]")?.value?.trim() || "",
      category: form.dataset.category || "other",
      pageUrl: window.location.href,
      turnstileToken,
    };
  }

  const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  // libphonenumber-js CDN 未読込時の fallback: 携帯 070/080/090 or IP 050 (11桁) / 固定 (10桁)
  const PHONE_RE_FALLBACK = /^(0[5789]0\d{8}|0(?![5789]0)\d{9})$/;
  function isValidJpPhone(digits) {
    const lp = window.libphonenumber;
    if (lp && typeof lp.isValidPhoneNumber === "function") {
      return lp.isValidPhoneNumber(digits, "JP");
    }
    return PHONE_RE_FALLBACK.test(digits);
  }
  const FIELD_SELECTOR = {
    name: 'input[name="contact[name]"]',
    email: 'input[name="contact[email]"]',
    phone: 'input[name="contact[phone]"]',
    body: 'textarea[name="contact[body]"]',
  };

  function validatePayload(payload) {
    if (!payload.name) return { field: "name", message: "お名前をご入力ください。" };
    if (!payload.email) return { field: "email", message: "メールアドレスをご入力ください。" };
    if (!EMAIL_RE.test(payload.email)) return { field: "email", message: "メールアドレスの形式が正しくありません。" };
    if (!payload.phone) return { field: "phone", message: "電話番号をご入力ください。" };
    if (!isValidJpPhone(payload.phone)) {
      return { field: "phone", message: "有効な日本の電話番号をご入力ください（ハイフン不要）。" };
    }
    if (!payload.body) return { field: "body", message: "お問い合わせ内容をご入力ください。" };
    return null;
  }

  function clearInlineErrors(form) {
    form.querySelectorAll(".chatbot-faq__field-error, .chatbot-faq__form-error").forEach((n) => n.remove());
  }

  function showFieldError(form, field, message) {
    const input = form.querySelector(FIELD_SELECTOR[field]);
    if (!input) return;
    const label = input.closest(".chatbot-faq__field") || input.parentNode;
    label.querySelectorAll(".chatbot-faq__field-error").forEach((n) => n.remove());
    const err = document.createElement("div");
    err.className = "chatbot-faq__field-error";
    err.textContent = message;
    label.appendChild(err);
    try { input.focus({ preventScroll: false }); } catch { input.focus(); }
  }

  function showSubmitError(form, message) {
    form.querySelectorAll(".chatbot-faq__form-error").forEach((n) => n.remove());
    const err = document.createElement("div");
    err.className = "chatbot-faq__form-error";
    err.textContent = message;
    const submitBtn = form.querySelector(".chatbot-faq__submit");
    if (submitBtn) form.insertBefore(err, submitBtn);
    else form.appendChild(err);
  }

  async function postToWorker(payload) {
    if (!workerUrl) throw new Error("workerUrl not configured");
    const res = await fetch(workerUrl + "/api/inquiry", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });
    if (!res.ok) {
      const data = await res.json().catch(() => ({}));
      const err = new Error(data?.error || "WORKER_FAILED");
      err.code = data?.error;
      err.message = data?.message || err.message;
      throw err;
    }
  }

  async function postToShopifyContact(form, payload) {
    const fd = new FormData();
    fd.append("form_type", "contact");
    fd.append("utf8", "✓");
    fd.append("contact[name]", payload.name);
    fd.append("contact[email]", payload.email);
    fd.append("contact[phone]", payload.phone);
    fd.append("contact[body]", payload.body);
    const res = await fetch("/contact", {
      method: "POST",
      body: fd,
      redirect: "manual",
      credentials: "same-origin",
    });
    // 302 → opaqueredirect、200 → ok いずれも成功扱い
    if (res.type !== "opaqueredirect" && !res.ok) {
      throw new Error("SHOPIFY_FAILED");
    }
  }

  async function handleSubmit(form, wrap) {
    setSubmitting(form, true);
    clearInlineErrors(form);
    try {
      const payload = buildPayload(form, "");
      const validationError = validatePayload(payload);
      if (validationError) {
        showFieldError(form, validationError.field, validationError.message);
        return;
      }
      const turnstileToken = readTurnstileToken();
      if (turnstileSiteKey && !turnstileToken) {
        showSubmitError(form, "人間確認が完了していません。チェックが終わるまで少々お待ちください。");
        return;
      }
      payload.turnstileToken = turnstileToken;

      // Step 1: Worker（Slack 通知 + Turnstile 検証 + rate-limit）
      // 受付の真は Slack 通知。ここが失敗したら本当の失敗
      await postToWorker(payload);

      // Step 2: Shopify /contact（自動返信メール）。失敗しても受付は成立しているので
      // ユーザーには成功を返し、Shopify 失敗は console に残してオペ側で追える形に
      try {
        await postToShopifyContact(form, payload);
      } catch (mailErr) {
        console.warn("[chatbot-faq] shopify /contact failed (slack already delivered)", mailErr);
      }

      rescueForm();
      wrap.remove();
      appendBubble(linkify(I18N.submit_success), "bot");
      submitted = true;
    } catch (err) {
      console.error("[chatbot-faq] submit failed", err);
      resetTurnstile();
      showSubmitError(form, I18N.submit_error);
    } finally {
      setSubmitting(form, false);
    }
  }

  function installFormHandler() {
    const form = formHost?.querySelector(".chatbot-faq__form");
    if (!form || form.dataset.handlerInstalled === "true") return;
    form.dataset.handlerInstalled = "true";
    form.addEventListener("submit", (e) => {
      e.preventDefault();
      const wrap = form.closest(".chatbot-faq__form-wrap");
      if (!wrap) return;
      handleSubmit(form, wrap);
    });
    const phoneInput = form.querySelector('input[name="contact[phone]"]');
    if (phoneInput) {
      phoneInput.addEventListener("input", () => {
        const digits = phoneInput.value.replace(/[^\d]/g, "").slice(0, 11);
        if (phoneInput.value !== digits) phoneInput.value = digits;
      });
    }
    Object.values(FIELD_SELECTOR).forEach((sel) => {
      const el = form.querySelector(sel);
      if (!el) return;
      el.addEventListener("input", () => {
        const field = el.closest(".chatbot-faq__field");
        if (field) field.querySelectorAll(".chatbot-faq__field-error").forEach((n) => n.remove());
      });
    });
  }
  installFormHandler();

  function appendActionLink(label, hrefFn) {
    const wrap = document.createElement("div");
    wrap.className = "chatbot-faq__choices";
    const a = document.createElement("a");
    a.className = "chatbot-faq__action chatbot-faq__action--primary";
    a.href = hrefFn();
    a.target = "_blank";
    a.rel = "noopener";
    a.textContent = label;
    wrap.appendChild(a);
    log.appendChild(wrap);
    log.scrollTop = log.scrollHeight;
  }

  const path = [];
  let currentNodeId = null;

  function updateBackButton() {
    if (!backBtn) return;
    const current = SCENARIO[currentNodeId];
    let canBack;
    if (!current) {
      canBack = false;
    } else if (current.type === "choice") {
      canBack = path.length > 1;
    } else {
      canBack = path.length > 0;
    }
    backBtn.disabled = !canBack;
  }

  function goTo(id, fromBack = false) {
    const node = SCENARIO[id];
    if (!node) return;

    // 遷移前に必ず form を formHost へ退避し、log 内の空 wrap を掃除
    rescueForm();
    log.querySelectorAll(".chatbot-faq__form-wrap").forEach((w) => {
      if (!w.querySelector(".chatbot-faq__form")) w.remove();
    });

    if (node.type === "choice" && !fromBack) {
      path.push(id);
    }
    currentNodeId = id;
    updateBackButton();

    if (node.type === "choice") {
      if (node.title) appendBubble(linkify(node.title), "bot");
      appendChoices(node);
      return;
    }

    if (node.type === "text") {
      appendBubble(linkify(node.body), "bot");
      if (node.followUp) appendActionLink(node.followUp.label, node.followUp.url);
      if (node.next) {
        setTimeout(() => goTo(node.next), 350);
      }
      return;
    }

    if (node.type === "form") {
      if (node.title) appendBubble(escapeHtml(node.title), "bot");
      if (node.body) appendBubble(linkify(node.body), "bot");
      // form の data-category をノードのカテゴリで更新してから表示
      const form = formHost?.querySelector(".chatbot-faq__form");
      if (form) form.dataset.category = node.category || "other";
      appendInlineForm(node);
      return;
    }

    if (node.type === "link") {
      if (node.body) appendBubble(linkify(node.body), "bot");
      appendActionLink(node.label || I18N.open_link, node.url);
      return;
    }
  }

  function back() {
    const current = SCENARIO[currentNodeId];
    if (!current) return;
    let target;
    if (current.type === "choice") {
      if (path.length <= 1) return;
      path.pop();
      target = path[path.length - 1];
    } else {
      if (!path.length) return;
      target = path[path.length - 1];
    }
    appendBubble(escapeHtml(I18N.back), "user");
    goTo(target, true);
  }

  function reset() {
    rescueForm();
    log.innerHTML = "";
    path.length = 0;
    currentNodeId = null;
    submitted = false;
    goTo("start");
  }

  function lockBodyScroll() {
    const scrollY = window.scrollY || window.pageYOffset || 0;
    document.body.dataset.chatbotFaqScrollY = String(scrollY);
    document.body.style.top = `-${scrollY}px`;
    document.body.classList.add("chatbot-faq-body--locked");
  }

  function unlockBodyScroll() {
    if (!document.body.classList.contains("chatbot-faq-body--locked")) return;
    const saved = parseInt(document.body.dataset.chatbotFaqScrollY || "0", 10);
    document.body.classList.remove("chatbot-faq-body--locked");
    document.body.style.top = "";
    delete document.body.dataset.chatbotFaqScrollY;
    window.scrollTo(0, saved);
  }

  function open() {
    panel.classList.add("chatbot-faq__panel--open");
    panel.setAttribute("aria-hidden", "false");
    launcher.setAttribute("aria-expanded", "true");
    launcher.classList.add("chatbot-faq__launcher--hidden");
    lockBodyScroll();
    if (!log.children.length || submitted) reset();
  }

  function close() {
    panel.classList.remove("chatbot-faq__panel--open");
    panel.setAttribute("aria-hidden", "true");
    launcher.setAttribute("aria-expanded", "false");
    launcher.classList.remove("chatbot-faq__launcher--hidden");
    unlockBodyScroll();
  }

  launcher.addEventListener("click", open);
  closeBtn.addEventListener("click", close);
  restartBtn.addEventListener("click", reset);
  if (backBtn) backBtn.addEventListener("click", back);

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && panel.classList.contains("chatbot-faq__panel--open")) close();
  });
})();
